export default "__VITE_ASSET__ClvfakVx__"